import { Result, PagedResult } from "../../../models/Result";
import { httpService } from "../../HttpService";
import { SearchRequestBaseModel } from "../../../models/SearchRequestModel";
import { ConfidentialClientViewModel, CreateConfidentialClientRequest, UpdateConfidentialClientRequest } from "../../../models/ConfidentialClientModel";

class ConfidentialClientApiService {
    private baseApiUrl = process.env.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_AUTH_API_BASE_URL;
    private path: string = "Client";

    GetScopes = async (): Promise<Result<string[]>> =>
        await httpService.get<string[]>(`/${this.path}/confidential/scopes`, { baseURL: this.baseApiUrl });

    Search = async (searchRequest: SearchRequestBaseModel): Promise<PagedResult<ConfidentialClientViewModel[]>> =>
        await httpService.getPage<ConfidentialClientViewModel[]>(`/${this.path}/confidential/search`, searchRequest, { baseURL: this.baseApiUrl });

    GetById = async (clientId: string): Promise<Result<ConfidentialClientViewModel>> =>
        await httpService.get<ConfidentialClientViewModel>(`/${this.path}/confidential/${clientId}`, { baseURL: this.baseApiUrl });

    Create = async (model: CreateConfidentialClientRequest): Promise<Result<unknown>> =>
        await httpService.post<unknown>(`/${this.path}/confidential`, model, { baseURL: this.baseApiUrl });

    Update = async (clientId: string, model: UpdateConfidentialClientRequest): Promise<Result<unknown>> =>
        await httpService.put<unknown>(`/${this.path}/confidential/${clientId}`, model, { baseURL: this.baseApiUrl });

    Delete = async (clientId: string): Promise<Result<unknown>> =>
        await httpService.delete<unknown>(`${this.baseApiUrl}/${this.path}/confidential/${clientId}`);
}

const confidentialClientApiService = new ConfidentialClientApiService();

export { confidentialClientApiService };
